var map = {
	"./Character.ts": 331,
	"./Character/amber.ts": 332,
	"./Character/hutao.ts": 333,
	"./Character/release.ts": 334,
	"./Test.ts": 335,
	"./ascension.ts": 336,
	"./common.ts": 337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;